// Pantallas de respaldo: un error inesperado (en vez de la pagina en blanco) y una direccion que no existe.
import { Link, useRouteError } from 'react-router-dom';

import { Empty } from './bits';

export function ErrorDePantalla() {
  const e = useRouteError() as Error | undefined;
  console.error('pantalla:', e);
  return (
    <div className="view" style={{ maxWidth: 640 }}>
      <section className="box">
        <Empty titulo="Algo falló en esta pantalla" texto="Recárgala; si vuelve a pasar, avísale a Xmartek con lo que estabas haciendo." icon="alert">
          <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
            <button className="btn primary" onClick={() => window.location.reload()}>
              Recargar
            </button>
            <a className="btn" href="/hoy">
              Ir a Hoy
            </a>
          </div>
        </Empty>
      </section>
    </div>
  );
}

export function NoEncontrado() {
  return (
    <div className="view" style={{ maxWidth: 640 }}>
      <section className="box">
        <Empty titulo="Esta página no existe" texto="Revisa la dirección o vuelve al inicio." icon="search">
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Link className="btn primary" to="/hoy">
              Ir a Hoy
            </Link>
          </div>
        </Empty>
      </section>
    </div>
  );
}
